import { Controller } from "@hotwired/stimulus";
import { loading } from "@/core/src";
import Swal from "sweetalert2";
import { analizadorRespuestaJson } from "../http_helpers";
import { html } from "code-tag";
function sePuedeDeshabilitar(v) {
    return "disabled" in v && typeof v.disabled === "boolean";
}
function erroresAInnerHtml(errores) {
    let mensajes = [];
    if (typeof errores === "string") {
        mensajes = [errores];
    }
    else if (typeof errores === "object") {
        if (errores && Array.isArray(errores)) {
            mensajes = (function* (errores) {
                for (const error of errores) {
                    if (typeof error === "string") {
                        yield error;
                    }
                }
            })(errores);
        }
    }
    return html `<ul>
        ${Array.from(mensajes).map((mensaje) => {
        return html `<li>${mensaje}</li>`;
    }).join("")}
    </ul>`;
}
export default class default_1 extends Controller {
    get form() {
        return this.element;
    }
    desplegarMensajeRespuesta(mensaje) {
        this.contenedorMensajeRespuestaTarget.innerHTML = mensaje;
    }
    async submitForm(event) {
        event.preventDefault();
        const analizarRespuestaJson = analizadorRespuestaJson({
            errorInterno(error) {
                console.error(error);
                Swal.fire({
                    text: "Se presento un problema inesperado en el servidor. Disculpe el inconveniente.",
                    icon: "error",
                });
            },
            errorFormatoIncorrecto(error) {
                console.error(error);
                Swal.fire({
                    text: "Se presento un problema inesperado en el servidor. Disculpe el inconveniente.",
                    icon: "error",
                });
            },
            errorContenidoInvalido: (error) => {
                this.desplegarMensajeRespuesta(erroresAInnerHtml(error.error));
                Swal.fire({
                    text: "Los datos recibidos son inválidos. Ver detalles en el formulario.",
                    icon: "error",
                });
            },
        });
        let manejarSubmitter = () => { return () => { }; }; // noop
        const submitter = event.submitter;
        if (sePuedeDeshabilitar(submitter)) {
            manejarSubmitter = () => {
                submitter.disabled = true;
                const loadingDone = loading(submitter, "Enviando...");
                return () => {
                    loadingDone();
                    submitter.disabled = false;
                };
            };
        }
        const finalizar = (() => {
            const finalizarSubmitter = manejarSubmitter();
            this.desplegarMensajeRespuesta("");
            return () => {
                finalizarSubmitter();
            };
        })();
        const form = this.form;
        let respuesta;
        try {
            respuesta = await analizarRespuestaJson(await window.fetch(form.action, {
                body: new FormData(form),
                method: form.method,
            }));
        }
        catch (error) {
            console.error(error);
            Swal.fire({
                text: "Se presento un problema desconocido. Disculpe el inconveniente.",
                icon: "error",
            });
        }
        finally {
            finalizar();
        }
        if (respuesta) {
            let mensajeExito = this.mensajeExitoPorDefectoValue;
            if (typeof respuesta === "object"
                && "mensaje" in respuesta
                && typeof respuesta.mensaje === "string") {
                mensajeExito = respuesta.mensaje;
            }
            Swal.fire({
                text: mensajeExito,
                icon: "success",
            });
        }
    }
}
default_1.values = {
    mensajeExitoPorDefecto: {
        type: String, default: "¡Formulario procesado exitosamente!"
    },
};
default_1.targets = [
    "contenedorMensajeRespuesta",
];
//# sourceMappingURL=async_form_controller.js.map